module.exports = __webpack_public_path__ + "static/media/spin.db0e9308.svg";